import { render, staticRenderFns } from "./BadgePosition.vue?vue&type=template&id=1240b080&"
import script from "./BadgePosition.vue?vue&type=script&lang=ts&"
export * from "./BadgePosition.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports